import Vector from "../vector";
export class IntConstVector extends Vector {
    constructor(name, value, sizeOrNullabilityBuffer) {
        super(name, Int32Array.of(value), sizeOrNullabilityBuffer);
    }
    getValueFromBuffer(_index) {
        return this.dataBuffer[0];
    }
}
//# sourceMappingURL=intConstVector.js.map